<amc-connect-home *ngIf="!showAmazonUI" class="connectHome"></amc-connect-home>
<div id="divConnectLib" [class]="{'hidden': !showAmazonUI}" [style.height]="amazonUIHeight + 'px'"> </div>
